import React from 'react';
import { Modal, Box, Typography, Button, Divider } from '@mui/material';

const ForceRefreshModal = ({ open, onClose, title, message, onConfirm, hideCancel = false }) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      window.location.reload();
    }
  };

  return (
    <Modal
      open={open}
      onClose={hideCancel ? undefined : onClose}
      aria-labelledby="force-refresh-modal-title"
      aria-describedby="force-refresh-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 420,
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
        }}
      >
        {title && (
        <Typography
          id="force-refresh-modal-title"
          variant="h6"
          gutterBottom
          sx={{ fontWeight: 600 }}
        >
          {title}
        </Typography>
        )}

        <Divider sx={{ mb: 3 }} />

        <Typography
          id="force-refresh-modal-description"
          sx={{ mb: 4, color: 'text.secondary', lineHeight: 1.6 }}
        >
          {message || 'Please refresh the page to continue.'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {!hideCancel && 
          <Button
            variant="outlined"
            color="secondary"
            sx={{ flex: 1 }}
            onClick={onClose}
          >
            Cancel
          </Button>
          }

          <Button
            variant="contained"
            color="primary"
            sx={{ flex: 1 }}
            onClick={handleConfirm}
          >
            Refresh
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ForceRefreshModal;
